import { FC } from "react";
import { Button } from "@/components/button";
import l from "@/locale";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Routes } from "@/types/routes";
import { logFirebaseEvent } from "@/services/firebase";
import { playSound, SoundOption } from "@/helpers/playSound";

const LanguageButtons: FC = () => {
  const {
    i18n: { language },
  } = useTranslation();
  const navigate = useNavigate();

  const languageOptions = [
    {
      label: "Nederlands",
      lng: "nl",
      changeLanguage: async () => await l.changeLanguage("nl"),
    },
    {
      label: "English",
      lng: "en",
      changeLanguage: async () => await l.changeLanguage("en"),
    },
    {
      label: "Deutsch",
      lng: "de",
      changeLanguage: async () => await l.changeLanguage("de"),
    },
  ].filter((lng) => lng.lng !== language);

  const handleClick = async (callback: () => void) => {
    callback();
    logFirebaseEvent("language_button_pressed", { language: language });
    if (window.location.pathname === Routes.START) navigate(Routes.MAIN);
    else {
      playSound(SoundOption.Click2Lo);
    }
  };

  return (
    <>
      {languageOptions.map(({ lng, label, changeLanguage }) => (
        <Button
          key={lng}
          text={label}
          onClick={() => handleClick(changeLanguage)}
          cta={false}
          size="x-small"
          data-cy={`language-button-${lng}`}
        />
      ))}
    </>
  );
};

export default LanguageButtons;
